import { useMemo } from "react";
import { sanitizeCommentHtml } from "@/lib/htmlSanitizer";

/**
 * Comments were authored in a rich-text editor, so the API returns HTML.
 * It is sanitised before it reaches `dangerouslySetInnerHTML` — the tag name
 * is the warning, `sanitizeCommentHtml` is the reason it is safe. The policy
 * itself lives in `@/lib/htmlSanitizer`, so what is allowed into a comment is
 * one reviewable list rather than a prop on a component.
 */
export function SafeHtml({ html, className }) {
  const clean = useMemo(() => sanitizeCommentHtml(html), [html]);

  // dangerouslySetInnerHTML is deliberate here; `clean` has been sanitised.
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
}
